import constants from '#packages/constants';

import { PANEL_NAME } from '../constants';
import * as utils from '../utils';

import type { EditorAPI } from '#packages/editorAPI';

const { COMP_TYPES } = constants;
const { getDeprecationData } = utils;

const deprecatedComponentsCtaActions = {
  [COMP_TYPES.HOVER_BOX]: {
    onCancel: (editorAPI: EditorAPI) => {
      editorAPI.panelManager.closePanelByName(PANEL_NAME);
    },
    onConfirm: (editorAPI: EditorAPI) => {
      const deprecationData = getDeprecationData(COMP_TYPES.HOVER_BOX);

      editorAPI.panelManager.openPanel(
        constants.ROOT_COMPS.LEFTBAR.ADD_PANEL_NAME,
        {
          origin: 'deprecationOverlay',
          category: deprecationData.MODAL_ACTIONS.ADD_PANEL.CATEGORY,
          sectionId: deprecationData.MODAL_ACTIONS.ADD_PANEL.SECTION,
        },
      );
    },
  },
};

export const getComponentCtaActions = (
  editorAPI: EditorAPI,
  compType: string,
) => {
  const defaultActions = {
    onCancel: () => {
      editorAPI.panelManager.closePanelByName(PANEL_NAME);
    },
    onConfirm: () => {
      editorAPI.panelManager.closePanelByName(PANEL_NAME);
    },
  };
  const actions = deprecatedComponentsCtaActions[compType];

  return {
    onCancel:
      actions.onCancel?.bind(null, editorAPI) ?? defaultActions.onCancel,
    onConfirm:
      actions.onConfirm?.bind(null, editorAPI) ?? defaultActions.onConfirm,
  };
};
